/**
 * File: apps/qbench-cp/reactapp/src/shared/components/FormV2/styles.js
 *
 * Purpose: Defines shared inline style objects for FormV2 input components, including the
 *     react-select style-function generator used by Select, AsyncSelect, MultiInput, and Tag.
 *
 * Scope: FormV2 input styling primitives.
 *
 * Tags: customer-portal
 *
 * Overview: Exports portalBaseStyle, a plain style object matching the bottom-bordered input
 *     look used across FormV2 text inputs. Exports reactSelectStyle(hidden, isMulti), a
 *     factory that returns a react-select `styles` prop object customizing the control,
 *     valueContainer, indicatorsContainer, menu, and option style functions — applying
 *     portalBaseStyle to the control, toggling row height between single and multi-select
 *     modes, hiding the control entirely when `hidden` is true, and dimming/disabling pointer
 *     behavior when the select is disabled.
 *
 * Exports: portalBaseStyle constant; reactSelectStyle(hidden, isMulti) factory function.
 */

export const portalBaseStyle = {
  width: '100%',
  fontSize: '14px',
  lineHeight: '20px',
  border: 'none',
  borderBottom: '1px solid #878787',
  borderRadius: '0',
  boxSizing: 'border-box',
  padding: '8px',
  marginBottom: '28px',
};

const getDisabledStyle = (state) => ({
  control: {
    ...(state.isDisabled && {
      opacity: 0.7,
      color: '#333',
      pointerEvents: 'auto',
      cursor: 'not-allowed',
      backgroundColor: '#f9f9f9',
    }),
  },
  option: {
    ...(state.isDisabled && { cursor: 'not-allowed' }),
  },
});

export const reactSelectStyle = (hidden = false, isMulti = false) => ({
  control: (base, state) => ({
    ...base,
    ...portalBaseStyle,
    ...getDisabledStyle(state).control,
    height: isMulti ? null : '40px',
    minHeight: isMulti ? '40px' : null,
    display: hidden ? 'none' : 'flex',
  }),
  valueContainer: (base, state) => ({
    ...base,
    padding: 0,
    height: isMulti ? null : '26px',
    minHeight: isMulti ? '26px' : null,
  }),
  indicatorsContainer: (base, state) => ({
    ...base,
    height: isMulti ? null : '26px',
    minHeight: isMulti ? '26px' : null,
  }),
  menu: (base, state) => ({
    ...base,
    zIndex: 10,
  }),
  option: (base, state) => ({
    ...base,
    ...getDisabledStyle(state).option,
  }),
});
